import request from '@/utils/bbs_request.js'
import qs from 'qs'
// 获取帖子信息 thread/thread/getThreadForTid
export function getThreadForTid(params) {
  return request({
    url: '/thread/thread/getThreadForTid',
    method: 'get',
    params
  })
}
// 帖子回复列表 /reply/reply/getReplysForTid
export function getReplysForTid(params) {
  return request({
    url: '/reply/reply/getReplysForTid',
    method: 'get',
    params
  })
}
// 回复点评分页列表 /reply/comment/getCommentLimit
export function getCommentLimit(params) {
  return request({
    url: '/reply/comment/getCommentLimit',
    method: 'get',
    params
  })
}
//  点赞/取消点赞（帖子和回复） /user/user/favoritesThread
export function favoritesThread(params) {
  return request({
    url: '/user/user/favoritesThread',
    method: 'get',
    params
  })
}
// 加热帖子 /thread/threadHot/addThreadHot
export function addThreadHot(params) {
  return request({
    url: '/thread/threadHot/addThreadHot',
    method: 'get',
    params
  })
}
// 取消加热帖子 /thread/threadHot/cancelThreadHot
export function cancelThreadHot(params) {
  return request({
    url: '/thread/threadHot/cancelThreadHot',
    method: 'get',
    params
  })
}
//  帖子收藏
export function collectThread(params) {
  return request({
    url: '/thread/thread/collectThread',
    method: 'get',
    params
  })
}
// 帖子取消收藏
export function cancelCollect(params) {
  return request({
    url: '/thread/thread/cancelCollect',
    method: 'get',
    params
  })
}
// 回复添加点评 /reply/comment/addcomment
export function addcomment(params) {
  return request({
    url: '/reply/comment/addcomment',
    method: 'get',
    params
  })
}
//  回复添加 /reply/reply/insertReply
export function insertReply(params) {
  return request({
    url: '/reply/reply/insertReply',
    method: 'get',
    params
  })
}
// 获取分享地址 /thread/thread/getShares
export function getShares(params) {
  return request({
    url: '/thread/thread/getShares',
    method: 'get',
    params
  })
}
// 获取分享地址 /thread/thread/getShares
export function getMiniprogram(params) {
  return request({
    url: '/thread/thread/getMiniprogram',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 是否关注了用户 user/follow/isfollow
export function isfollow(params) {
  return request({
    url: '/user/follow/isfollow',
    method: 'get',
    params
  })
}
// 关注用户 /user/follow/follow
export function follow(params) {
  return request({
    url: '/user/follow/follow',
    method: 'get',
    params
  })
}
// 取消关注用户 /user/follow/cancelFollow
export function cancelFollow(params) {
  return request({
    url: '/user/follow/cancelFollow',
    method: 'get',
    params
  })
}

// 推荐链接
export function getInner(params) {
  return request({
    url: '/recommend/recommend/getInner',
    method: 'get',
    params
  })
}

// 页面审核员
export function getQrCode(params) {
  return request({
    url: '/thread/thread/getQrCode',
    method: 'get',
    params
  })
}

// 帖子管理员
export function isGroupManager(params) {
  return request({
    url: '/user/user/isGroupManager',
    method: 'get',
    params
  })
}

// 删除主贴
export function deleteThread(params) {
  return request({
    url: 'thread/thread/deleteThread',
    method: 'get',
    params
  })
}

// 删除回复
export function deleteReply(params) {
  return request({
    url: '/reply/reply/deleteReply',
    method: 'get',
    params
  })
}

// 删除回复
export function getAgencyAppList(params) {
  return request({
    url: '/index/index/getAgencyAppList',
    method: 'get',
    params
  })
}
